module.exports = __webpack_public_path__ + "static/media/icon_azure-datalake.b48e128f.svg";